// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3kx_g","buttons":"SendReceipts_buttons__Bsbpp","email":"SendReceipts_email__1Kgd6","bookApptTitle":"SendReceipts_bookApptTitle__2_p99"};